import { updateCookieParam, checkAcceptCookies } from './cookies.js';
import { dontSubmitEmptyFormInputs } from './formTools.js';
export default function initHeaderSearchForm() {
  const searchForm = document.getElementById('SearchForm') as HTMLFormElement;
  if (!searchForm) return;


  let jobs = document.getElementById("search-jobs-btn");
  let jobseekers = document.getElementById("search-jobseekers-btn");
  let query = document.getElementById("search-query-btn");
  let jobTypesSelect = document.getElementById("JobTypes") as HTMLInputElement;
  let placeOrPostcode = document.getElementById("PlaceOrPostcode") as HTMLInputElement;
  let querysearch = document.getElementById("Query") as HTMLInputElement;
  let btnGPS = document.getElementById("btn-search-gps");
  let lat = document.getElementById("search-lat") as HTMLInputElement;
  let lng = document.getElementById("search-lng") as HTMLInputElement;
  let gpsFeedback = document.getElementById("search-gps-feedback");
  let usingGPS = false;

  dontSubmitEmptyFormInputs(searchForm);

  //On change of jobtype or location, sets the name attribute of the element to the correct value. This is if the user submits the form and then cancels, then changes the values again.
  [jobTypesSelect, placeOrPostcode].forEach((element) => {
    element.addEventListener("change", function (e) {
      let target = e.target as HTMLInputElement;
      if (target.id == "JobTypes") {
        target.setAttribute("name", "jobTypes");
      } else if (target.id == "PlaceOrPostcode") {
        target.setAttribute("name", "Location");
      }
    });
  });

  [jobs, jobseekers, query].forEach((element) => {
    element.addEventListener("click", changeAction);
  });

  btnGPS.addEventListener("click", getGPS);

  function changeAction(e) {
    let selectedClass = "bg-gray-200";
    const element = e.target;
    const action = element.getAttribute("data-action");
    const searchForm = document.getElementById('SearchForm') as HTMLFormElement;
    searchForm.action = action;

    jobs.classList.remove(selectedClass);
    jobseekers.classList.remove(selectedClass);
    query.classList.remove(selectedClass);


    querysearch.classList.add("d-none");
    element.classList.add(selectedClass);
    jobTypesSelect.classList.remove("d-none");
    placeOrPostcode.classList.remove("d-none");
    placeOrPostcode.classList.remove("rounded-start");
    placeOrPostcode.setAttribute("placeholder", "Place or Postcode");
    placeOrPostcode.setAttribute("name", "location");
    btnGPS.classList.remove("d-none");

    if (element == query) {
      jobTypesSelect.classList.add("d-none");
      querysearch.classList.remove("d-none");
      placeOrPostcode.classList.add("d-none");
      placeOrPostcode.classList.add("rounded-start");
      placeOrPostcode.setAttribute("placeholder", "Listing Id");
      placeOrPostcode.setAttribute("name", "q");
      btnGPS.classList.add("d-none");
      showGPSFeedback(null);
    }
  }

  //Without any feedback the button looked dead whenever the browser refused a location: there
  //was no error callback, so a blocked permission (or a browser with no geolocation, or a lookup
  //that never answered) simply did nothing.
  function showGPSFeedback(message: string | null) {
    if (!gpsFeedback) return;
    gpsFeedback.textContent = message ?? "";
    gpsFeedback.classList.toggle("d-none", !message);
  }

  function setGPSBusy(busy: boolean) {
    btnGPS.classList.toggle("disabled", busy);
    btnGPS.setAttribute("aria-busy", busy.toString());
    if (busy) {
      placeOrPostcode.setAttribute("placeholder", "Finding your location...");
    } else if (!usingGPS) {
      placeOrPostcode.setAttribute("placeholder", "Place or Postcode");
    }
  }

  function getGPS() {
    if (usingGPS) {
      placeOrPostcode.removeAttribute("disabled");
      placeOrPostcode.setAttribute("placeholder", "Place or Postcode");
      lat.setAttribute("disabled", "true");
      lng.setAttribute("disabled", "true");
      btnGPS.classList.remove("active");
      usingGPS = false;
      showGPSFeedback(null);
      return;
    }

    if (!navigator.geolocation) {
      showGPSFeedback("Your browser can't share your location. Type a place or postcode instead.");
      return;
    }

    showGPSFeedback(null);
    setGPSBusy(true);

    navigator.geolocation.getCurrentPosition((pos) => {
      usingGPS = true;
      setGPSBusy(false);
      placeOrPostcode.setAttribute("disabled", "true");
      placeOrPostcode.setAttribute("placeholder", "Using GPS");
      btnGPS.classList.add("active");
      lat.value = pos.coords.latitude.toFixed(2);
      lng.value = pos.coords.longitude.toFixed(2);

      lat.removeAttribute("disabled");
      lng.removeAttribute("disabled");
      updateCookieParam("AnonUser", "Latitude", lat.value);
      updateCookieParam("AnonUser", "Longitude", lng.value);
    }, (error) => {
      setGPSBusy(false);

      if (error.code === error.PERMISSION_DENIED) {
        showGPSFeedback("Location access is blocked for this site. Allow it in your browser's site settings, or type a place or postcode.");
      } else if (error.code === error.TIMEOUT) {
        showGPSFeedback("Finding your location took too long. Try again, or type a place or postcode.");
      } else {
        showGPSFeedback("We couldn't find your location. Type a place or postcode instead.");
      }
    }, { timeout: 10000, maximumAge: 300000 });
  }
}